import React from "react";
import Skills from "./Skills";

const Aboutme = () => {
	return (
		<div className="bg-dark pb-4" style={{ height: "950px",width:"100vw" }}>
			<div className="container">
				<div className="row">
					<div className="col-md-12 pt-5 text-white text-center">
						<h5 className="diaplay-6">Hello,I&apos;m</h5>
						<h1 className="display-1">Fahim Alif</h1>
 
						<p className="display-6">
              A passionate developer committed to life-long learning. I develop
              web applications whether front-end or back-end. My core skills are
              based on Javascript and love to code in Javascript. I am available
              for any kind of job opportunity that suits my interests.
						</p>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<Skills />
					</div>
				</div>
       
				{/* <div className="row"> */}
				{/* <div className="col-md-5 pt-5 text-white"> */}
				{/* <h5 className="diaplay-6">Hello,I'm</h5> */}
				{/* <h1 className="display-1">Fahim Alif</h1> */}
				{/* <p className="display-6">A developer committed to life-long learning.Loves to learn new technologies whether it's front-end  or back-end.Interested in Javascript && React.js  </p> */}
				{/* 
            <p className="display-6">
              A passionate developer committed to life-long learning. I develop
              web applications whether front-end or back-end. My core skills are
              based on Javascript and love to code in Javascript. I am available
              for any kind of job opportunity that suits my interests.
            </p> */}
				{/* </div> */}
				{/* <div className="col-md-7">
            <Skills />
          </div> */}
				{/* </div> */}
			</div>
		</div>
	);
};

export default Aboutme;
